module.exports = __webpack_public_path__ + "fonts/fa-regular-400.40e6df55.ttf";